var jCube = require('./core'),
    vars  = require('./variables');

var getCompareFunction = function(comparator) {
    return jCube.isString(comparator) ? function (i, ele) {
        return jCube.h.matches(ele, comparator);
    } : jCube.isFunction(comparator) ? comparator : jCube.isCubeJS(comparator) ? function (i, ele) {
        return comparator.is(ele);
    } : function (i, ele) {
        return ele === comparator;
    };
};

jCube.fn.toArray = function() {
    return vars.slice.call( this );
};

jCube.fn.eq = function( index ) {
    return jCube(this.get(index));
};

jCube.fn.is = function (comparator) {
    if (!comparator || !this[0]) return false;
    var compare = getCompareFunction(comparator);
    var check = false;
    this.each(function (i, ele) {
        check = compare.call(ele, i, ele);
        return !check;
    });
    return check;
};

jCube.fn.not = function (comparator) {
    if (!comparator || !this[0]) return this;
    var compare = getCompareFunction(comparator);
    return this.filter(function (i, ele) {
        return !compare.call(ele, i, ele);
    });
};

jCube.fn.end = function() {
    return this.prevObject || this.constructor(null);
};

jCube.fn.get = function( index ) {
    if (index === undefined) return vars.slice.call(this);
    return this[index < 0 ? index + this.length : index];
};

jCube.fn.add = function (selector, context) {
    return jCube(jCube.h.unique(this.get().concat(jCube(selector, context).get())));
};

jCube.fn.empty = function () {
    return jCube.each(function (i, ele) {
        while (ele.firstChild) {
            ele.removeChild(ele.firstChild);
        }
    });
};

jCube.fn.html = function (html) {
    if (html === undefined) return this[0] && this[0].innerHTML;

    return jCube.each(this, function (i, ele) {
        ele.innerHTML = html;
    });
};

// Take an array of elements and push it onto the stack
// (returning the new matched element set)
jCube.fn.pushStack = function( elems ) {

    var ret = jCube.merge( this.constructor(), elems );

    ret.prevObject = this;
    ret.context = this.context;

    return ret;
};

jCube.fn.find = function (selector) {

    var result = [];

    for (var i = 0, l = this.length; i < l; i++) {
        var found = jCube.find(selector, this[i]);

        if (found.length) {
            vars.push.apply(result, found);
        }
    }

    return jCube(jCube.h.unique(result));
};

jCube.fn.filter = function (comparator) {
    if (!comparator) return jCube();
    var compare = getCompareFunction(comparator);
    return jCube(vars.filter.call(this, function (ele, i) {
        return compare.call(ele, i, ele);
    }));
};

jCube.fn.closest = function (comparator) {
    if (!comparator || !this[0]) return jCube();
    var filtered = this.filter(comparator);
    if (filtered.length) return filtered;
    return this.parent().closest(comparator);
};

jCube.fn.parent = function (comparator) {
    return jCube.h.filtered(jCube(jCube.h.unique(jCube.h.pluck(this, 'parentNode'))), comparator);
};

jCube.fn.each = function( callback, args ) {
    return jCube.each( this, callback, args );
};

jCube.fn.map = function( callback ) {
    return jCube( vars.map.call(this, function( elem, i ) {
        return callback.call( elem, i, elem );
    }));
};

jCube.fn.slice = function() {
    return jCube(vars.slice.apply(this, arguments));
};

jCube.fn.first = function() {
    return this.eq( 0 );
};

jCube.fn.last = function() {
    return this.eq( -1 );
};